export default "__VITE_ASSET__DvZiH5nE__"